<div class="ark-toolbar-container">
  @if (title) {
    <h2 class="ark-h2 col p-0">{{ title }}</h2>
  }

  <!--#region Inputs -->
  @if (
    activeSearchInput ||
    activeTagsInput ||
    activeGeneralTagsInput ||
    onActiveFilterCustomInput ||
    selectAll
    ) {
    <div
      class="ark-inputs-toolbar-container col"
      >
      <!--#region SelectAll-->
      @if (
        selectAll &&
        !activeSearchInput &&
        !activeTagsInput &&
        !activeGeneralTagsInput
        ) {
        <div style="display: flex; align-items: center; margin-bottom: 10px">
          @if (selectCardService.selection.hasValue()) {
            <div
              style="display: flex; align-items: center">
              <mat-checkbox
                [checked]="true"
                (change)="selectCardService.selectCard($event, null, key)"
                color="primary"
              style="margin-left: 5px"></mat-checkbox>
              <div style="display: flex; align-items: center; margin-left: 5px">
                <span
                  ><strong>{{ 'general.Deselect' | translate }}</strong></span
                  >
                  <span
                    class="ark-selectionCounter-number"
                    style="margin-left: 5px"
                    >{{ selectCardService.selection.selected.length }}</span
                    >
                  </div>
                </div>
              }
              @if (!selectCardService.selection.hasValue()) {
                <div
                  style="margin-left: 5px; display: flex; align-items: center">
                  <mat-checkbox
                    color="primary"
                    (change)="selectCardService.selectCard($event)"
                  style="margin-left: 5px"></mat-checkbox>
                  <span style="margin-left: 5px"
                    ><strong>{{ 'general.SelectAll' | translate }}</strong></span
                    >
                  </div>
                }
              </div>
            }
            @if (activeSearchInput) {
              <div class="col order-2 order-md-1 ark-content-input-toolbar">
                <mat-form-field
                  class="ark-input-full-width ark-input-search-toolbar-content">
                  <mat-label class="ark-mat-label">{{
                    'general.Search' | translate
                  }}</mat-label>
                  @if (criteria.value) {
                    <a
                      mat-icon-button
                      matPrefix
                      aria-label="Limpiar"
                      (click)="onCriteriaClearAndEmit()"
                      ><i class="fal fa-times"></i
                    ></a>
                  }
                  <input
                    matInput
                    [formControl]="criteria"
                    autocomplete="off"
                    (keydown)="keyDownFunction($event)"
                    #search />
                    @if (criteria.value) {
                      <a
                        matSuffix
                        class="btn ark-btn-action ark-mat-suffix"
                        title="Buscar"
                        color="primary"
                        (click)="criteriaSearch()"
                        >
                        <span><i class="fal fa-search"></i></span>
                      </a>
                    }
                  </mat-form-field>
                </div>
              }
              <!--#endregion -->
              <!--#region Input de tags -->
              @if (activeTagsInput) {
                <app-selector-chips
                  class="col order-2 order-md-1 ark-content-input-toolbar"
                  [title]="'general.Tags' | translate"
                  [selectorOptions]="filteredTagsOptions"
                  (changedOptions)="selectedTag($event)"
                  [optionsList]="arkTags"
                  [_module]="_module">
                </app-selector-chips>
              }
              <!--#endregion -->
              <!--#region Input de tags -->
              @if (activeGeneralTagsInput) {
                <app-selector-chips-tabs
                  class="col order-2 order-md-1 ark-content-input-tabs-toolbar"
                  [title]="'general.searchByNameOrTags' | translate"
                  [selectorOptions]="filteredGeneralTagsOptions"
                  [selectorGeneralOptions]="filteredGeneralOptions"
                  [optionsListTag]="arkTags"
                  (changedOptions)="selectedTag($event)"
                  [_module]="_module"
                  [excludedMediaType]="excludedMediaType"
                  [mediaType]="mediaType"
                  [locationId]="locationId"
                  [version]="version">
                </app-selector-chips-tabs>
              }
              <!--#endregion -->
              <!--#region Input custom filter only audit component -->
              @if (onActiveFilterCustomInput) {
                <div class="col-12 col-md-auto order-2 order-md-1">
                  <mat-form-field class="ark-input-full-width">
                    <mat-label class="ark-mat-label">{{
                      customFilter.TitleInput
                    }}</mat-label>
                    <mat-select>
                      @for (filter of customFilter.Options; track filter.Key) {
                        <mat-option
                          [value]="filter.Key"
                          (click)="onFilterCustom(filter.Key)"
                          (keydown.enter)="onFilterCustom(filter.Key)">
                          {{ filter.Text }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              }
              <!--#endregion -->
            </div>
          }
          <!--#endregion -->

          <!--Button search, tags and customFilter-->
          <div class="ark-actions-toolbar-container">
            <!--#region Actions buttons-->
            <ng-container>
              <!--#region search-->
              @if (searchBtn) {
                <a
                  class="btn ark-btn-action GA-toolbar-search"
                  matTooltip="{{ 'general.Search' | translate }}"
                  (click)="onActiveSearchInput()"
                  [ngClass]="{ active: activeSearchInput }">
                  <i class="fal fa-search GA-toolbar-search"></i>
                </a>
              }
              <!--#endregion -->

              <!--#region sync integration-->
              @if (syncIntegrationBtn && integrationId) {
                <a
                  class="btn ark-btn-action GA-toolbar-search"
                  matTooltip="{{ 'integrations.Sync' | translate }}"
                  (click)="syncIntegration.emit()">
                  <i
                    class="fal"
          [ngClass]="
            isSynchronizingIntegration
              ? 'fa-spinner fa-spin'
              : 'fa-arrows-rotate'
          "></i>
                </a>
              }
              <!--#endregion -->

              <!--#region tags-->
              @if (tagsBtn) {
                <a
                  class="btn ark-btn-action GA-toolbar-tags"
                  matTooltip="{{ 'general.Tags' | translate }}"
                  (click)="onActiveTags()"
                  [ngClass]="{ active: activeTagsInput }">
                  <i class="fal fa-tag GA-toolbar-tags"></i>
                </a>
              }
              <!-- #endregion -->

              <!--#region tags-->
              @if (generalTagsBtn) {
                <a
                  class="btn ark-btn-action GA-toolbar-tags"
                  matTooltip="{{ 'general.Search' | translate }}"
                  (click)="onActiveTagsTabs()"
                  [ngClass]="{ active: activeGeneralTagsInput }">
                  <i class="fal fa-search GA-toolbar-search"></i>
                </a>
              }
              <!-- #endregion -->

              <!--#region filter only audit component-->
              @if (customFilter.Active) {
                <a
                  class="btn ark-btn-action"
                  matTooltip="{{ 'general.Filter' | translate }}"
                  (click)="onActiveFilterCustom()"
                  [ngClass]="{ active: onActiveFilterCustomInput }">
                  <i class="fal fa-filter"></i>
                </a>
              }
              <!--#endregion -->

              <!--#endregion custom filters table-->
              @if (customFilterTableBtn) {
                <a
                  class="btn ark-btn-action"
                  matTooltip="{{ 'general.Filter' | translate }}"
                  (click)="activateCustomFiltersTable()"
                  [ngClass]="{ active: customFiltersTableService.activateFilters }">
                  <i class="fal fa-filter"></i>
                </a>
              }
              <!--#endregion -->

              <!--#endregion custom filters by Chips-->
              @if (customFilterChipsBtn) {
                <a
                  class="btn ark-btn-action"
                  matTooltip="{{ 'multimedia.MediaFilterByUsed' | translate }}"
                  (click)="activateCustomFilterChips()"
                  [ngClass]="{ active: showFilterByChips }">
                  <i class="fal fa-filter"></i>
                </a>
              }
              <!--#endregion -->

              <!--#region Buttons grid and sort-->
              @if (gridTableBtn) {
                @if (!toggleCardList) {
                  <a
                    class="btn ark-btn-action GA-toolbar-toggle-card"
                    matTooltip="{{ 'general.Grid' | translate }}"
                    (click)="toggleCardListActive()">
                    <i class="fal fa-table GA-toolbar-toggle-card"></i>
                  </a>
                }
                @if (toggleCardList) {
                  <a
                    class="btn ark-btn-action GA-toolbar-toggle-card"
                    matTooltip="{{ 'general.Table' | translate }}"
                    (click)="toggleCardListActive()">
                    <i class="fal fa-th-list GA-toolbar-toggle-card"></i>
                  </a>
                }
                @if (toggleCardList && sortBtnCardList) {
                  <a
                    class="btn ark-btn-action"
                    matTooltip="{{ 'general.Sort' | translate }}"
                    [matMenuTriggerFor]="optionsSortBy"
                    [ngClass]="{ active: sortActive }">
                    <i class="fal fa-sort-amount-down"></i>
                  </a>
                  <mat-menu #optionsSortBy="matMenu">
                    @for (sort of sortBy; track $index) {
                      <button
                        mat-menu-item
                        class="tk-btn-menu"
                        (click)="onSearchSortOrder(sort)"
                        [ngClass]="{ active: sort.Active }"
                        [disabled]="sort.Active">
                        {{ sort.ViewValue }}
                      </button>
                    }
                  </mat-menu>
                }
              }
              <!--#endregion -->
            </ng-container>
            <!--#endregion -->

            <!--#region sortBtn-->
            @if (sortBtn) {
              <a
                class="btn ark-btn-action"
                matTooltip="{{ 'general.Sort' | translate }}"
                [matMenuTriggerFor]="optionsSortBy"
                [ngClass]="{ active: sortActive }">
                <i class="fal fa-sort-amount-down"></i>
              </a>
              <mat-menu #optionsSortBy="matMenu">
                @for (sort of sortBy; track sort.Value) {
                  <button
                    mat-menu-item
                    class="tk-btn-menu"
                    (click)="onSearchSortOrder(sort)"
                    [ngClass]="{ active: sort.Active }"
                    [disabled]="sort.Active">
                    {{ sort.ViewValue | translate }}
                  </button>
                }
              </mat-menu>
            }
            <!--#endregion -->

            <!--#region refresh button-->
            @if (refreshBtn) {
              <a class="btn ark-btn-action">
                <app-refresh-and-loader
                  id="refreshButton"
                  (reloadContent)="reloadContent.emit()"
                  [autoLoadingMode]="autoLoadingMode"
                  [loading]="loading"
                  [activateCountdown]="activateCountdown"
                  [loadDuration]="loadDuration"
                [hideHoverBtn]="hideHoverBtn"></app-refresh-and-loader>
              </a>
            }
            <!--#endregion -->

            <!--#region Button options-->
            @if (options.Active) {
              <a
                class="btn ark-btn-action"
                matTooltip="{{ 'general.Options' | translate }}"
                [matMenuTriggerFor]="optionsTable">
                <i class="fal fa-ellipsis-v"></i>
              </a>
              <mat-menu #optionsTable="matMenu">
                @for (option of options.Options; track option.Key) {
                  @if (option.Options) {
                    <button
                      mat-menu-item
                      [matMenuTriggerFor]="options"
                      [disabled]="!hasAnyPermission(option.Permissions)"
                      (click)="onOptionsSelected(option)">
                      <i [ngClass]="option.Icon"></i
                        ><span class="ml-2"> {{ option.PublicKey | translate }}</span>
                      </button>
                      <mat-menu #options="matMenu">
                        @for (secundaryOption of option.Options; track secundaryOption.Key) {
                          <button
                            mat-menu-item
                            (click)="onOptionsSelected(secundaryOption)">
                            {{ secundaryOption.PublicKey | translate }}
                          </button>
                        }
                      </mat-menu>
                    }
                    @if (!option.Options) {
                      <button
                        mat-menu-item
                        [disabled]="!hasAnyPermission(option.Permissions)"
                        (click)="onOptionsSelected(option)">
                        <i [ngClass]="option.Icon"></i
                          ><span class="ml-2"> {{ option.PublicKey | translate }}</span>
                        </button>
                      }
                    }
                  </mat-menu>
                }
              </div>
              <!--#endregion -->

              <!--#region Call to action of section with options-->
              @if (callToActionText) {
                @if (selectorOptions) {
                  <a
                    mat-raised-button
                    class="btn ark-btn"
                    color="primary"
                    (click)="selectorDevice.emit()">
                    <span>{{ callToActionText }}</span>
                  </a>
                }
              }
              <!--#endregion-->

              <!--#region Call to action of section without options-->
              @if (callToActionText && !selectorOptions) {
                <a
                  mat-raised-button
                  class="btn ark-btn"
                  color="primary"
                  (click)="callToAction.emit()">
                  <span>{{ callToActionText }}</span>
                </a>
              }
              <!--#endregion-->
            </div>

            <!--#region Custom filters-->
            @if (customFilterTableBtn) {
              <div class="col col-12 p-0">
                <app-custom-filter
                  (selectedCustomFilter)="selectedCustomFilter.emit($event)"
                  #customFilterTable>
                </app-custom-filter>
              </div>
            }
            <!--#endregion-->

            @if (customFilterChipsBtn) {
              <div>
                <app-custom-filter-chips
                  [setShowFilter]="showFilterByChips"
                  [setCustomChipFilter]="customFiltersChips"
                  (selectedCustomFilterChip)="selectedCustomFilter.emit($event)"
                (hiddenFilter)="showFilterByChips = false"></app-custom-filter-chips>
              </div>
            }
